import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { SUBMISSIONS } from '../constants'

const updateSubmissionHide = async ({
  campaignId,
  id,
}: {
  campaignId: number
  id: number
}) => {
  await fetchAPI({
    method: 'put',
    path: `/campaigns/${campaignId}/submissions/${id}/hide`,
  })
}

export const useUpdateSubmissionHide = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateSubmissionHide, {
    onSuccess: async () => {
      await queryClient.refetchQueries([SUBMISSIONS])

      toast({
        description: t('views.admin.campaigns.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
